export default __webpack_public_path__ + "static/media/ic-download.19aea67d.svg";